<template>
  <p v-if="tag" class="tag">{{ tag }}</p>
</template>

<script>
export default {
  data () {
    return {
      daysOfTheWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    }
  },
  props: {
    house: Object
  },
  computed: {
    tag () {
      let tag = ''

      // Off Market
      if (this.house.special_circumstances && this.house.special_circumstances === 'Off Market') {
        tag = 'Off Market'

      // Pending
      } else if (this.house.status && ['Pending', 'Contingent'].includes(this.house.status)) {
        tag = 'Pending/Contingent'

      // Next Open House
      } else if (this.house.open_houses && this.house.open_houses.length) {
        let weekLater = new Date()
        weekLater.setDate(weekLater.getUTCDate() + 6)

        let firstOpenHouse = this.house.open_houses.slice().sort((a, b) => (b.start_date < a.end_date) ? 1 : -1)[0]
        let startTimeDate = new Date(firstOpenHouse.start_date)
        let startTimePeriod = startTimeDate.getUTCHours() >= 12 ? 'pm' : 'am'
        let startTimeHour = startTimeDate.getUTCHours() > 12 ? startTimeDate.getUTCHours() - 12 : startTimeDate.getUTCHours()
        let formattedStartTime = startTimeHour.toString() + (startTimeDate.getUTCMinutes() ? ':' + startTimeDate.getUTCMinutes().toString() : '') + startTimePeriod

        let endTimeDate = new Date(firstOpenHouse.end_date)
        let endTimePeriod = endTimeDate.getUTCHours() >= 12 ? 'pm' : 'am'
        let endTimeHour = endTimeDate.getUTCHours() > 12 ? endTimeDate.getUTCHours() - 12 : endTimeDate.getUTCHours()
        let formattedEndTime = endTimeHour.toString() + (endTimeDate.getUTCMinutes() ? ':' + endTimeDate.getUTCMinutes().toString() : '') + endTimePeriod

        if (startTimeDate < weekLater) {
          tag = 'Open House: ' + this.daysOfTheWeek[startTimeDate.getUTCDay()] + ' ' + formattedStartTime + ' - ' + formattedEndTime
        } else {
          tag = 'Open House: ' + (startTimeDate.getUTCMonth() + 1).toString() + '/' + startTimeDate.getUTCDate().toString() + ' ' + formattedStartTime + ' - ' + formattedEndTime
        }
      } else {
        let today = new Date()
        let weekLater = null
        let downloadTime = null
        if (this.house.download_time) {
          downloadTime = new Date(this.house.download_time)
          weekLater = new Date(downloadTime)
          weekLater.setDate(weekLater.getUTCDate() + 7)
        }

        // New Listing (7 days)
        if (today < weekLater) {
          let now = new Date()
          let differenceInSeconds = (now.getTime() - downloadTime.getTime()) / 1000
          if (differenceInSeconds < 60 * 60) return 'New: ' + Math.round(differenceInSeconds / 60).toString() + ' Minutes ago'
          if (differenceInSeconds < 60 * 60 * 24) return 'New: ' + Math.round(differenceInSeconds / (60 * 60)).toString() + ' Hours ago'
          if (differenceInSeconds < 60 * 60) return 'New: ' + Math.round(differenceInSeconds / (60 * 60 * 24)).toString() + ' Days ago'
        }

        weekLater = null
        let lastPriceChange = null
        let priceChangeDate = null
        if (this.house.price_history) {
          lastPriceChange = this.house.price_history.slice().sort((a, b) => (b.date < a.date) ? 1 : -1)[0]
          priceChangeDate = new Date(lastPriceChange.date)
          weekLater = new Date(priceChangeDate)
          weekLater.setDate(weekLater.getUTCDate() + 7)
        }

        // Price Reduced (7 days)
        if (priceChangeDate < weekLater && lastPriceChange.description === 'Price Reduction') return lastPriceChange.description
      }

      return tag
    }
  }
}
</script>

<style scoped>
.tag {
  background-color: rgba(0, 0, 0, .7);
  color: var(--secondary-background-color) !important;
  font-size: 0.8rem;
  margin-bottom: 0;
  position: absolute;
  padding-bottom: 0.15rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/home/HouseTag.vue